import { render } from "./HazLicenseStorageLocationTable.vue?vue&type=template&id=4207c437"
import script from "./HazLicenseStorageLocationTable.vue?vue&type=script&lang=js"
export * from "./HazLicenseStorageLocationTable.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__